export default {"src":"/_next/static/media/sao-tome-and-principe.8a74cb01.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};